import { render, staticRenderFns } from "./UnlockPro.vue?vue&type=template&id=bbbdd96a"
import script from "./UnlockPro.vue?vue&type=script&lang=js"
export * from "./UnlockPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports